import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';

const GettingStarted = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Using Spatial Grid"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={HelpCenterLvl_2_1}
      basePath="/help-center/using-spatialgrid-articles"
      breadcrumbPath={{
        name: 'Using-Spatialgrid',
        path: '/help-center/using-spatialgrid',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={9}
      seeAllLink="/help-center/using-spatialgrid-articles"
    />
  );
};

export default GettingStarted;
